// FUNÇÕES/MÓDULOS SITE
import HoverBackgroundGradient from './modules/Animation/hover_bg-gradient'
import AnimationElements  from './modules/Animation/enterElements'
import AnchorLinks from './modules/Utils/anchor_links'
import ImageEnter from './modules/Animation/imageEnter'
import ImagesHovers from './modules/Animation/imageHovers'
import { Menu } from './modules/Layouts/menu'
import budgetForm from './modules/Forms/budgetForm'
import changeCities from './modules/Utils/changeCities';
// import { sliderProducts } from './modules/Components/sliderProducts'

// import Footer from './modules/Layouts/footer'
// import ScrollSmooth from './modules/Animation/scrollLenis'

try {
    Menu()
} catch (error) {
    
}

// sliderProducts()

// Animations
AnimationElements()
HoverBackgroundGradient()
ImageEnter()
ImagesHovers()
// ScrollSmooth()

// Utils
AnchorLinks()

// Layout
// Footer()


$("[data-bs-dismiss]").on('click', function(e) {
    $("#sidebar-orcamento").removeClass('show');
})

budgetForm();
changeCities();

// whatsapp floating btn opacity
function iconOpacity() {
    if ( window.scrollY >= 100 ) {
        $('#footer .floating').css({ opacity: '1' });
    } else {
        $('#footer .floating').css({ opacity: '0' });
    }
}

$(window).on('scroll', iconOpacity);